var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cls_not_found"},[_c('el-image',{staticStyle:{"margin":"auto"},attrs:{"src":require('@/assets/images/404.png')}}),_c('el-button',{attrs:{"size":"medium","type":"primary"},on:{"click":_vm.back}},[_vm._v("返回")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }